export default __webpack_public_path__ + "static/media/no-icon.d5b16fc5.png";